<template lang="jade">
  div.Input(
    ":tooltip"="fdata.tip || false"
    ":error"="error"
    v-bind:class="{'Input--filled': formInput }"
  )
    input.Input__field(
      type="text"
      ":disabled"="!fdata.editable"
      v-model="formInput"
      ":class"="fdata.class"
      ":placeholder"="fdata.placeholder"
      "v-bind:class"="{ 'Input__field--invalid': error }"
      ":name"="fdata.field"
      ":required"="required"
    )
    label.Input__label
      span.Input__label-content
        i.fa.fa-globe(style="margin-right: 10px")
        {{ fdata.label }}
    //- template(v-if="error")
    //-   partial(name="error")
</template>

<script>
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: ''
      }
    },
    computed: {
      validate () {
        let input = this.formInput === undefined || this.formInput === '' ? '' : this.formInput.toLowerCase()
        return this.computedValidate(this.fdata, input)
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          if (val.editable === false) {
            val.field = false
          }
          return val
        }
      }
    },
    ready () {
      this.formInput = this.fdata.value
    }
  }
</script>



// WEBPACK FOOTER //
// url.vue?d48eea30